<template>
    <div>
        <b-navbar toggleable="md" type="dark" variant='dark'>
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand to="/"><img src='/rcfbbook1200.png' class='brand-image' /></b-navbar-brand>
            <b-collapse is-nav id="nav_collapse">
                <b-navbar-nav>
                    <b-nav-item>
                        <router-link to="/" class='nav-link'>Home</router-link>
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav v-if='profile'>
                    <b-nav-item>
                        <router-link to="/history" class='nav-link'>History</router-link>
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav>
                    <b-nav-item>
                        <router-link to="/leaderboard" class='nav-link'>Leaderboard</router-link>
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav>
                    <b-nav-item>
                        <router-link to="/about" class='nav-link'>About</router-link>
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
    export default {
        name: 'Navigation',
        props: ['profile']
    };

</script>

<style lang="scss">
    .brand-image {
        height: 30px;
        width: 30px;
    }
</style>
